module.exports = __webpack_public_path__ + "img/smile.9b9dbe47.png";